import { createdCoreTable } from '../components/core-table'
import { coreTableProps } from '../props'
import { LEFT_TABLE } from '../config'

const CoreTable = createdCoreTable()
export function createLeftTable() {
  return {
    name: 'LeftTable',
    props: coreTableProps,
    render() {
      const coreTableAttribute = {
        props: {
          ...this.$props,
          type: LEFT_TABLE
        },
      }
      return (
        this.$props.columns.length ? <CoreTable {...coreTableAttribute} ref="leftTable">
            {this.$slots.default}
          </CoreTable>
        : null
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/layout/left-table.js